<footer class="app-footer">
    <div class="app-footer__content">
        <section class="app-footer__sections" aria-label="Secciones principales">
            <article class="app-footer__section" *ngFor="let section of sections; trackBy: trackByLabel">
                <div class="app-footer__section-heading">
                    <a
                        class="app-footer__section-link"
                        [href]="section.href || '#'"
                        [target]="section.target || null"
                        [rel]="getRel(section.target)">
                        {{ section.label }}
                    </a>

                    <button
                        class="app-footer__section-toggle"
                        type="button"
                        [attr.aria-label]="isSectionExpanded(section.label) ? 'Contraer ' + section.label : 'Desplegar ' + section.label"
                        [attr.aria-expanded]="isSectionExpanded(section.label)"
                        [attr.aria-controls]="getSectionId(section.label)"
                        (click)="toggleSection(section.label)">
                        <svg class="app-footer__section-arrow" viewBox="0 0 20 20" aria-hidden="true">
                            <path d="M7 4.5L12.5 10L7 15.5" />
                        </svg>
                    </button>
                </div>

                <nav
                    *ngIf="section.items?.length"
                    class="app-footer__subsections"
                    [class.app-footer__subsections--open]="isSectionExpanded(section.label)"
                    [id]="getSectionId(section.label)"
                    [attr.aria-label]="section.label">
                    <a
                        class="app-footer__subsection-link"
                        *ngFor="let item of section.items; trackBy: trackByLabel"
                        [href]="item.href || '#'"
                        [target]="item.target || null"
                        [rel]="getRel(item.target)">
                        {{ item.label }}
                    </a>
                </nav>
            </article>
        </section>

        <div class="app-footer__bottom">
            <nav class="app-footer__legal-links" aria-label="Enlaces legales">
                <span class="app-footer__legal-item" *ngFor="let link of legalLinks; let last = last; trackBy: trackByLabel">
                    <a [href]="link.href || '#'" [target]="link.target || null" [rel]="getRel(link.target)">
                        {{ link.label }}
                    </a>
                    <span class="app-footer__legal-separator" *ngIf="!last">|</span>
                </span>
            </nav>

            <nav class="app-footer__social-links" aria-label="Redes sociales" *ngIf="socialLinks.length > 0">
                <a
                    class="app-footer__social-link"
                    *ngFor="let link of socialLinks; trackBy: trackByLabel"
                    [href]="link.href || '#'"
                    [target]="link.target || null"
                    [rel]="getRel(link.target)"
                    [attr.aria-label]="link.ariaLabel || link.label"
                    [title]="link.label">
                    {{ link.label }}
                </a>
            </nav>
        </div>
    </div>
</footer>
